import { LANGUAGE } from "_constants";

const MESSAGES_EN: Record<string, string> = {
  "1110": "Warm Up", //?
  "1111": "First Set", //?
  "1112": "Second Set", //?
  "1113": "Singles Serve",
  "1114": "Tie Break Point",
  "1115": "Match Point",
  "1116": "Game, Set and Match", //?
  "1117": "Match Completed", //?
  "1118": "Failed", //?
  "1120": "Stats",
};

const MESSAGES_ALB: Record<string, string> = { ...MESSAGES_EN };

export const MESSAGES = {
  [LANGUAGE.ENGLISH]: MESSAGES_EN,
  [LANGUAGE.ALBANIAN]: MESSAGES_ALB,
};
